// OLD
export const SOFTLINE_API_ESL_FLASH_EXISTS = '/v1/esl/exists/{{idartstamm}}';
export const SOFTLINE_API_ESL_FLASH = '/v1/esl/flash';
export const SOFTLINE_API_ESL_CHECK = '/v1/esl/exists/{{itemId}}';

// NEW
export const SOFTLINE_API_ESL_EXISTS = '/esl-service/esl/exists/{{itemId}}';
export const SOFTLINE_API_ESL_FLASH_LED = '/esl-service/esl/flash';
export const SOFTLINE_API_ESL_SWITCH_SCENARIO =
  '/esl-service/esl/switchScenario/{{type}}';
